import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import MyLayout from './Components/MyLayout/MyLayout';
import LocationList from './Pages/LocationList/LocationList';
import LocationCard from './Pages/LocationCard/LocationCard';
import UserManager from './Pages/UserManager/UserManager';
import UserManagerCard from './Pages/UserManagerCard/UserManagerCard';
import History from './Pages/History/History';
import { Freespace } from './Pages/Freespace/Freespace';
import HistoryLocationList from './Pages/HistoryLocationList/HistoryLocationList';

function App() {
  return (
    <Routes>
    <Route path="/" element={<MyLayout />}>
        <Route path="/" element={<LocationList />}></Route>
        <Route path="/locations" element={<LocationList />}></Route>
        <Route path="/locations/f" element={<LocationList />}></Route>
        <Route path="/locations/:guid" element={<LocationCard />} />
        <Route path="/freespace/:guid" element={<Freespace />} />
        <Route path="/locations/new" element={<LocationCard />} />
        <Route path="/usermanager/" element={<UserManager />} />
        <Route path="/usermanager/:uid" element={<UserManagerCard />} />
        <Route path="/history/:guid" element={<History />} />
        <Route path="/history/" element={<HistoryLocationList />} />
      </Route>
    </Routes>

  );
}

export default App;
